/**
 * API Configuration
 * Environment-based API endpoints
 */

const ENV = process.env.NODE_ENV || 'development';

// API Base URLs
const API_URLS = {
  development: process.env.REACT_APP_API_URL || 'https://api-stage.ziyadha.com/api/',
  production: process.env.REACT_APP_API_URL || 'https://api.ziyadha.com/api/',
};

export const API_BASE_URL = API_URLS[ENV === 'production' ? 'production' : 'development'];

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: 'auth/login',
    REGISTER: 'auth/register',
    ME: 'auth/me',
    FORGOT_PASSWORD: 'auth/forgot-password',
    RESET_PASSWORD: 'auth/reset-password',
    CHANGE_PASSWORD: 'auth/change-password',
  },

  // User/Customer endpoints
  USERS: 'users',

  // Product endpoints
  PRODUCTS: 'products/permit-all',

  // Category endpoints
  CATEGORIES: 'categories/list/permit-all',

  // Order endpoints
  ORDERS: 'orders',

  // Contact endpoints
  CONTACT: 'contact-request/permit-all',
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
};
